"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var colors_1 = __importDefault(require("../../assets/jss/colors"));
var colorsV2_1 = __importDefault(require("../../assets/jss/colorsV2"));
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a, _b, _c, _d, _e;
    return (0, styles_1.makeStyles)({
        srOnly: {
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            border: 0
        },
        root: {
            backgroundColor: colors_1.default.textSecondaryColor.hex(),
            zIndex: 1,
            color: colors_1.default.white.hex(),
            width: 30,
            height: 30,
            display: 'flex',
            borderRadius: '50%',
            justifyContent: 'center',
            alignItems: 'center'
        },
        active: {
            backgroundColor: theme.palette.primary.main
        },
        completed: {
            backgroundColor: theme.palette.primary.main
        },
        container: __assign(__assign({}, material_kit_pro_react_1.container), (_a = { display: 'flex', flexGrow: 1, alignItems: 'center', justifyContent: 'center' }, _a[theme.breakpoints.down('md')] = {
            minWidth: '450px'
        }, _a[theme.breakpoints.down('xs')] = {
            paddingLeft: 0,
            paddingRight: 0
        }, _a)),
        registerCard: (_b = {
                background: theme.palette.background.default,
                borderRadius: '10px',
                marginTop: theme.spacing(6),
                marginBottom: theme.spacing(4),
                paddingTop: theme.spacing(4),
                paddingBottom: theme.spacing(6)
            },
            _b[theme.breakpoints.down('xs')] = {
                marginTop: theme.spacing(4),
                paddingTop: theme.spacing(2)
            },
            _b),
        titleText: (_c = {},
            _c[theme.breakpoints.down('xs')] = {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(3.5)
            },
            _c[theme.breakpoints.up('sm')] = {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(3.5)
            },
            _c),
        fieldContainer: {
            padding: theme.spacing()
        },
        fieldTerms: (_d = {
                paddingTop: 0
            },
            _d[theme.breakpoints.up('md')] = {
                justifyContent: 'flex-start'
            },
            _d),
        termText: (_e = {},
            _e[theme.breakpoints.up('md')] = {
                textAlign: 'left'
            },
            _e),
        field: {
            width: '100%',
            '& ::placeholder': {
                color: colorsV2_1.default.palette.neutralsN600.hex(),
                opacity: 1
            },
            '& ::-webkit-input-placeholder': {
                color: colorsV2_1.default.palette.neutralsN600.hex(),
                opacity: 1
            },
            '& :-ms-input-placeholder': {
                color: colorsV2_1.default.palette.neutralsN600.hex(),
                opacity: 1
            },
            '& ::-ms-input-placeholder': {
                color: colorsV2_1.default.palette.neutralsN600.hex(),
                opacity: 1
            }
        },
        errorCheckbox: {
            padding: theme.spacing() / 2,
            cursor: 'default',
            '& span': {
                color: theme.palette.success.main
            }
        },
        confirmIcon: {
            fontSize: '120px',
            color: theme.palette.primary.main,
            margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(3), "px")
        },
        confirmRow: {
            padding: theme.spacing()
        },
        textButton: {
            textTransform: 'none',
            paddingTop: theme.spacing(1),
            marginBottom: theme.spacing(3),
            fontSize: '16px'
        },
        button: {
            '&.MuiButton-containedPrimary.Mui-disabled': {
                backgroundColor: colors_1.default.textSecondaryColor.hex(),
                color: theme.palette.text.disabled
            },
            '&:disabled': {
                backgroundColor: colors_1.default.textSecondaryColor.hex(),
                color: theme.palette.text.disabled
            },
            minWidth: '250px',
            minHeight: '50px'
        },
        stepper: {
            padding: 0,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            backgroundColor: 'transparent'
        },
        addressContent: {
            paddingLeft: theme.spacing(),
            paddingRight: theme.spacing()
        },
        link: {
            padding: 0,
            minWidth: 'auto',
            textDecoration: 'underline',
            '&:hover, &:focus': {
                textDecoration: 'underline'
            }
        },
        newTabIcon: {
            marginLeft: theme.spacing(1)
        },
        passwordStrengthContainer: {
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(3.5)
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map